export enum SmsRoles {
  EMPLOYEE = 'SMS EMPLOYEE',
  MANAGER = 'SMS MANAGER',
  USER = 'SMS USER',
}
